(function($) {

    $(document).ready(function() {

        if (!$('.intro-block .title-wrap').length > 0) {
            $('.intro-block').addClass('no-title');
        }

        $('a[name="button"]').each(function() {
            $(this).addClass("btn-red-border");
        });

        if ($('.arcgis1').length > 0) {
            $('.arcgis1').parents('.full-content').addClass('no-padding');
            $('.arcgis1').parents('.full-content').find('.container').removeClass('container');
        }

        $(document).on('click', '.intro-block.research-detail .read-more.click-me', function(e) {
            setTimeout(function() {
                var height = $(".intro-block.research-detail .description-wrap").outerHeight();
                $(".intro-block.research-detail .description-wrap").css('height', height + 'px');
            }, 100);
        });
        $(document).on('click', '.intro-block.research-detail .read-more.click-me-again', function(e) {
            $(".intro-block.research-detail .description-wrap").css('height', '525px');
            setTimeout(function() {
                $(".intro-block.research-detail .description-wrap").removeAttr("style");
            }, 1200);
        });

        $(document).on('click', '.intro-block.research-detail .read-more', function(e) {
            var className = $(this).text();
            if (className == "Read More") {
                $(this).text('Read Less');
                $('.intro-block.research-detail .description-wrap').addClass('open');
                $('.intro-block.research-detail .read-more').addClass('click-me-again');
                $('.intro-block.research-detail .read-more').removeClass('click-me');
            } else {
                $('.intro-block.research-detail .description-wrap').removeClass('open');
                $('.intro-block.research-detail .read-more').addClass('click-me');
                $('.intro-block.research-detail .read-more').removeClass('click-me-again');
                $(this).text('Read More');
            }
        });



        $('.intro-block .description-wrap .read-more').click(function() {
            var className = $(this).text();
            if (className == "Read More") {
                // $(this).parent().find('.content').slideDown();
                $(this).text('Read Less');
                $('.intro-block.research-detail .description-wrap').addClass('open');
            } else {
                $('.intro-block.research-detail .description-wrap').removeClass('open');
                // $(this).parent().find('.content').slideUp();
                $(this).text('Read More');
            }
        });

        $(document).on('click', '.intro-block.research-detail .read-more', function() {
            headerHeight = $(".intro-block.research-detail").offset().top - $("header").outerHeight() - $(".sticky-nav").outerHeight();
            $("html, body").animate({
                    scrollTop: headerHeight,
                },
                600,
                "linear"
            );
        });


        $(".intro-block.research-detail .row-wrap").append('<span class="read-more click-me">Read More</span>');


        var height = $(".intro-block.research-detail .description-wrap").height();
        if (height > 525) {
            $(".intro-block.research-detail .description-wrap .read-more").show();
        } else {
            $(".intro-block.research-detail .description-wrap .read-more").hide();
        }
        // Clone the title in title div
        // if ($('.team .description-wrap').length > 0) {
        //   var title = $('.team .description-wrap').find('h2').text();
        //   $('.intro-block.research-detail .description-wrap h2').remove();
        //   $('.team .title-wrap h3').text(title);
        // }

        $('.intro-block').each(function() {
            if ($(this).find(' .watermark-wrapper').length > 0) {

                $(this).find('.bg-img > img').wrap('<div class="inner-wrapper"></div>');
                $(this).find('.bg-img').addClass('overflow');

            }
        });

        if ($('.intro-block.research-detail .description-wrap').length > 0) {
            // $('.intro-block.research-detail .description-wrap p').addClass('info');
            // $('.intro-block.research-detail .description-wrap p:eq(0)').removeClass('info');
            // $('.intro-block.research-detail .description-wrap p:eq(1)').removeClass('info');
            // $('.intro-block.research-detail .description-wrap .info').wrapAll('<div class="content"/>');
        }
    });

    $(window).on("load", function() {
        $(".intro-block .description-wrap article img").each(function() {
            var width = $(this).width();
            $(this).parent().next("figcaption").css("width", width + "px");
        });

        $(".intro-block.research-detail .description-wrap .read-more").remove();
        var height = $(".intro-block.research-detail .description-wrap").height();
        if (height > 525) {
            $(".intro-block.research-detail .description-wrap").addClass("max-height");
            $(".intro-block.research-detail .read-more").show();
        } else {
            $(".intro-block.research-detail .description-wrap").removeClass("max-height");
            $(".intro-block.research-detail .read-more").hide();
        }

    });
    $(window).on("load resize", function() {
        var $height = $(".link-grid.links-list .row-wrapper .row-wrapper").outerHeight();
        var $total_height = 90 + ($height / 2);
        $(".link-grid.links-list .row-wrapper .row-wrapper").removeAttr("style");
        setTimeout(function() {
            $(".link-grid.links-list .row-wrapper .row-wrapper").css("height", $total_height + "px");
        }, 800);
    });
})(jQuery);